import { render, staticRenderFns } from "./AppItemDetailInbox.vue?vue&type=template&id=7acab114&"
import script from "./AppItemDetailInbox.vue?vue&type=script&lang=js&"
export * from "./AppItemDetailInbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports